const normalizeText = (value, fallback = '') => String(value ?? fallback).trim();

export const normalizeBrandLabel = (value, fallback = 'Sin marca') => {
  const normalized = normalizeText(value, fallback);
  return normalized || fallback;
};

export const normalizeBrandKey = (value, fallback = 'Sin marca') =>
  normalizeBrandLabel(value, fallback)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase();

export const buildBrandOptions = (items, getBrand, fallback = 'Sin marca') => {
  const groupedBrands = new Map();

  (items || []).forEach((item) => {
    const brandLabel = normalizeBrandLabel(getBrand(item), fallback);
    const brandKey = normalizeBrandKey(brandLabel, fallback);

    if (!groupedBrands.has(brandKey)) {
      groupedBrands.set(brandKey, { value: brandKey, label: brandLabel });
      return;
    }

    const current = groupedBrands.get(brandKey);
    if (brandLabel.localeCompare(current.label, 'es', { sensitivity: 'base' }) < 0) {
      groupedBrands.set(brandKey, { value: brandKey, label: brandLabel });
    }
  });

  return Array.from(groupedBrands.values()).sort((a, b) =>
    a.label.localeCompare(b.label, 'es', { sensitivity: 'base' })
  );
};
